/* !
 * jQuery recipe v1.0.0
 * Copyright 2021, Connecty Inc.
 */
(function($, FUNCTIONS){

	// ＜レシピTOP＞ピックアップ 空要素削除
	const removeEmptyPickup = () => {
		$('.recipe-idx-pickup').find('li').each((idx, ele) => {
			if (!$(ele).find('a').length) {
				$(ele).remove();
			} else if (!$(ele).find('.rt_cf_r_cooking_time').length) {
				$(ele).find('.__time').remove();
			}
		});
		if (!$('.recipe-idx-pickup').find('li').length) {
			$('.recipe-idx-pickup').remove();
		}
	};

	// ＜レシピTOP＞カテゴリ別レシピ出力
	const getJSONCategoryRecipeList = (_category) => {
		return $.getJSON(`/ajax/recipe/${_category}/recipe.json`);
	};
	const setCategoryRecipeList = () => {
		$('.js-categoryRecipeList').each((idx, ele) => {
			let category = $(ele).find('.rt_cf_rc_name').attr('data-rc_code');
			getJSONCategoryRecipeList(category).then((data) => {
				if (data.rt_bn_recipe_list.length) {
					let recipeListHTML = '';
					for (let i = 0; i < data.rt_bn_recipe_list.length; i++) {
						recipeListHTML += '<li class="pure-u-1-4 pure-u-lg-1-2 space-u-40-child">' +
							`<a href="/recipe/${data.rt_bn_recipe_list[i].cf_r_category.cf_rc_code}/${data.rt_bn_recipe_list[i]._key}.html" class="di_block">` +
							`<figure><img src="/recipe/recipe_file/file/${data.rt_bn_recipe_list[i].cf_r_image}" alt="${data.rt_bn_recipe_list[i].cf_r_image_title}" class="width-u-100">` +
							'<figcaption>';
						if (data.rt_bn_recipe_list[i].cf_r_cooking_time) {
							recipeListHTML += '<span class="__time"><svg><use xlink:href="/common/svg/sprite.svg#time" /></svg>' +
								`調理時間：<span>${data.rt_bn_recipe_list[i].cf_r_cooking_time}分</span></span>`;
						}
						recipeListHTML += `<p class="__title">${data.rt_bn_recipe_list[i].cf_r_image_title}</p></figcaption></figure></a></li>`;
					}
					$(ele).find('.mod-recipeList').append(recipeListHTML);
				} else {
					$(ele).remove();
				}
			});
		});
	};

	// ＜レシピカテゴリ一覧＞空要素削除
	const removeEmptyRecipeList = () => {
		$('.mod-recipeList').find('li').each((idx, ele) => {
			if (!$(ele).find('.rt_cf_r_cooking_time').length) {
				$(ele).find('.__time').remove();
			}
		});
	};

	// ＜レシピ詳細＞材料：非表示出力の各値を移動
	const setDetailIngredients = () => {
		// 材料：分量目安
		if ($('.rt_cf_ri_amount').eq(0).text().length) {
			$('.js-amount').text($('.rt_cf_ri_amount').eq(0).text());
		} else {
			$('.js-amountWrap').remove();
		}
		$('.rt_cf_ri_amount').remove();

		// 材料グループ名
		$('.__ingre_group').each((idx, ele) => {
			if ($(ele).find('.rt_cf_ri_group_name').length) {
				$(ele).find('h4').html(`<span>${$(ele).find('.rt_cf_ri_group_name').eq(0).text()}</span>`+
					`<span class="__sub">${$(ele).find('.rt_cf_ri_sub_group_name').eq(0).text()}</span>`);
				$(ele).find('.rt_cf_ri_group_name').remove();
				$(ele).find('.rt_cf_ri_sub_group_name').remove();
			} else {
				$(ele).find('h4').remove();
			}
		});
	};

	// ========= ↑↑ FUNCTIONS ↑↑ ========================================================================== //

	if (FUNCTIONS.va.pathname === '/recipe/' || FUNCTIONS.va.pathname === '/recipe/index.html') { // レシピTOP
		removeEmptyPickup();
		setCategoryRecipeList();
	} else if (FUNCTIONS.va.pathname.indexOf('/recipe/') !== -1 && !FUNCTIONS.va.pathname.split('/')[3]) { // レシピカテゴリ一覧
		removeEmptyRecipeList();
	} else { // レシピ詳細
		setDetailIngredients();
		removeEmptyRecipeList();
	}

})(window.jQuery, window.FUNCTIONS);
